import getMaxFavoriteSuggestionCounts from './getMaxFavoriteSuggestionCounts';
import { isSearchInFavorites } from 'owa-favorites';
import { getUserConfiguration } from 'owa-session-store';
export default function getFavoriteSearchSuggestions(findText) {
    var searchHistory = getUserConfiguration().ViewStateConfiguration.SearchHistory;
    var searchSuggestions = [];
    for (var _i = 0, searchHistory_1 = searchHistory; _i < searchHistory_1.length; _i++) {
        var searchEntry = searchHistory_1[_i];
        if (searchEntry.toLowerCase().indexOf(findText.toLowerCase()) == 0) {
            searchSuggestions.push(searchEntry);
        }
    }
    // Filter out search queries that:
    // 1) are already favorites or
    // 2) are empty string searches
    // 3) contain KQL from queries (we want users to add favorite people instead)
    searchSuggestions = searchSuggestions.filter(function (searchQuery) {
        return !isSearchInFavorites(searchQuery) &&
            searchQuery.trim() != '' &&
            searchQuery.toLowerCase().indexOf('from:') == -1;
    });
    var maxSearchSuggestions = getMaxFavoriteSuggestionCounts().search;
    searchSuggestions.splice(maxSearchSuggestions);
    return searchSuggestions.map(function (seachEntry) {
        return {
            data: seachEntry,
            id: seachEntry,
            type: 2 /* Search */,
            relevance: 0 /* Relevance scores will be supplied by providers in the future */,
        };
    });
}
//# sourceMappingURL=getFavoriteSearchSuggestions.js.map